export const comments_3787338 = {"data":{"data":[],"links":{}}}